import React, { useState, useContext } from 'react';
import Text from '../components/elements/Text';
import { NavLink, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { BsGoogle } from 'react-icons/bs';
import { useAuth } from '../context/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const ForgetPassword = () => {
    const navigate = useNavigate();
    const { user, updateUser } = useAuth();
    const [email, setEmail] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [isLogin, setIsLogin] = useState(true);
    //Check upload
    
    const onEmailChange = (e) => {
        setEmail(e.target.value);
        setIsEmailValid(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value));
    }

    const onSubmit = async (e) => {
        e.preventDefault();

        const response = await fetch(`${process.env.REACT_APP_MANAGEMENT_SERVER_URL}/forgetPassword`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
              
            },
            body: JSON.stringify({
                email,
                "agentapp": process.env.REACT_APP_API_HEADER
            }),
        });

        if (response.ok) {
            const data = await response.json();
            localStorage.setItem("forgetPassEmail",email)
            navigate('/confirmForgetPassword'); // Redirect to the login page
            toast.success('Please check your email address!', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000,
            });
        } else {
            setIsLogin(false);
            toast.error('Incorrect email address!', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000,
            });
        }
    };
    ;
    // }


    return (
        <main >
            <section>
                <div className="flex h-screen items-center justify-center px-4 sm:px-6 lg:px-8">
                    <div className="w-full max-w-md space-y-8">
                        <div>
                            <div className="py-2 px-16 text-center">
                                <NavLink to="/admin/dashboard">
                                    <img src={process.env.REACT_APP_LOGO} alt="ShopAgent Logo" className="text-3xl font-bold uppercase no-underline dark:text-white" />
                                </NavLink>
                            </div>

                            <h2 className="text-white text-center text-base  tracking-tight text-gray-900">
                            Forgot Your Password?
                            </h2>
                            <p className="text-light-gray text-center text-base  tracking-tight text-gray-900">
                            We're here to help.  Please enter your email address associated with your account, and we'll send you a code to reset your password.
                            </p>
                            {!isLogin && (
                                <p className="text-red-500 text-center mt-2 validation">Invalid email address!</p>
                            )}
                        </div>


                        <form onSubmit={onSubmit} className="mt-8 space-y-6" >
                            <div className=" space-y-6 rounded-md shadow-sm">
                                <div>
                                    <label htmlFor="email-address" className="sr-only">
                                        Email address
                                    </label>
                                    <input
                                        type="email"
                                        label="Email address"
                                        value={email}
                                        onChange={onEmailChange}
                                        required
                                        className="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                        placeholder="Email address"
                                    />
                                </div>
                                {!isEmailValid && (
                                    <span className="text-red-500 text-xs mt-1 validation">
                                        Please enter a valid email address.
                                    </span>
                                )}
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                >
                                    Submit
                                </button>
                            </div>

                        </form>


                        <p className="text-sm text-white text-center">
                            Go back ?{' '}
                            <NavLink to="/login" className="underline text-tertiary">
                                 Sign in
                            </NavLink>
                        </p>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default ForgetPassword